import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Pirati",
  "description": "",
  "published": "2006-08-22T00:00:00.000Z",
  "redirect_from": ["/blog/pirati/swizec/385"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`V zadnjem èasu je internetno pazljivo oko se ¾e davno umaknilo s Piratov 2, ampak nekateri smo si jih ogledali šele v soboto in zganili svoje riti šele danes, da bi o njih kaj povedali, c'est la vie.`}</p>
    <p>{`Te¾ko se je odloèiti kam toèno bi uvrstil Pirate 2, na eni strani sem jaz, ljubitelj filmov, ki se dobro poslušajo, se pravi so prijetni za muziciranje v ozadju, na drugi strani pa sem jaz, ljubitelj posebnih efektov in velikih reèi. Prvi pirati so definitivno film, ki se odlièno posluša, veliko dobrega in zanimivega dialoga, ne preveè moteèih elementov in odlièna glasbena podlaga. Pirati 2 to definitivno niso, so èisto nasprotje tega, Pirati 2 so spektakel in za kaj veè bi jih bilo te¾ko jemati. Film je gledljiv nekako v stilu kot je gledljiv na primer Rambo, kaj veè bi pa bilo te¾ko prièakovati.`}</p>
    <p>{`Kar se tièe samih posebnih uèinkov pa kapo dol. vse skupaj je odlièno izpeljano, uporabljena je zanimiva tehnika, ki je tokrat res prinesla 3D animacije v takih detajlih kot verjetno še lep èas ne bodo standard v filmih. Bral sem tudi nekaj èlankov o postopku dela in stvar je res sapo jemajoèa.`}</p>
    <p>{`Prišli smo torej do dela novice, ki se dotika septemberskega stripa, še vedno mi je ¾al za poletje brez novih delov.`}</p>
    <p>{`Strip je dobil lasten storyboard, ki je sluèajno tudi moj prvi. V izdelavo še ni šel, ker moram najprej ustvariti tri dizajne ter se ponovno nauèiti kako se nariše nekatere dotiène stvari, ki so se mi uspele nekako izmuzniti. Mislim, da lahko z skorajšnjo gotovostjo reèem, da bo strip narejen ob pravem èasu, kdaj toèno ta èas je pa naj ostane skrivnost.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      